"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[620],{

/***/ 1166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);





var BlurImage = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref[0], setLoading = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        alt: props.alt,
        className: "".concat(props.className, " duration-700 ease-in-out ").concat(isLoading ? "grayscale blur-2xl scale-110" : "grayscale-0 blur-0 scale-100"),
        onLoadingComplete: function() {
            return setLoading(false);
        }
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BlurImage);


/***/ }),

/***/ 3620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@tawk.to/tawk-messenger-react/dist/tawk-messenger-react.es.js
var tawk_messenger_react_es = __webpack_require__(9318);
// EXTERNAL MODULE: ./node_modules/@use-cookie-consent/react/build/index.es.js
var index_es = __webpack_require__(7351);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-scroll-to-top/dist/index.js
var dist = __webpack_require__(5301);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./lib/baseUrl.ts
var baseUrl = __webpack_require__(9836);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/SpeakerphoneIcon.js
var SpeakerphoneIcon = __webpack_require__(3268);
;// CONCATENATED MODULE: ./components/CookieConsentBanner.tsx



var CookieConsentBanner = function() {
    var acceptAllCookies = (0,index_es/* useCookieConsentContext */.uz)().acceptAllCookies;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "fixed inset-x-0 bottom-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-secondary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-3 py-3 mx-auto max-w-7xl sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center flex-1 w-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "flex p-2 rounded-lg bg-primary",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerphoneIcon/* default */.Z, {
                                            className: "w-6 h-6 text-white",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "ml-3 font-medium text-white truncate",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "md:hidden",
                                                children: "Allow cookies"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "hidden md:inline",
                                                children: "This website uses 3rd party cookies to improve your experience."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-shrink-0 order-3 w-full mt-2 sm:order-2 sm:mt-0 sm:w-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "flex items-center justify-center px-4 py-2 text-sm font-medium bg-white border border-transparent rounded-md shadow-sm text-primary hover:bg-indigo-50",
                                    onClick: acceptAllCookies,
                                    children: "Accept Cookies"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-shrink-0 order-2 sm:order-3 sm:ml-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var components_CookieConsentBanner = (CookieConsentBanner);

// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./public/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.acfa5eb4.png","height":512,"width":1539,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEWgwKKh0XSLzo82r+poxLtEtN7cLwzCAAAABnRSTlMBGCseU36yyvyeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGUlEQVR4nGNgZGJkAAMWViZmZkZGRgaYCAABvwAddWT7SQAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./components/SocialMediaIcons.tsx
var SocialMediaIcons = __webpack_require__(1692);
;// CONCATENATED MODULE: ./components/Footer.tsx





var Footer = function(param) {
    var commonPages = param.commonPages;
    var footerLinks = [
        {
            title: "Hair Transplant Before After Gallery",
            href: "/before-after-gallery"
        },
        {
            title: "Hair Transplant Prices in Turkey and UK",
            href: "/hair-transplant-prices"
        },
        {
            title: "Our Blog Posts",
            href: "/blog"
        },
        {
            title: "Affiliate Program",
            href: "/affiliate-program"
        },
        {
            title: "How to Book Your Travel",
            href: "/how-to-book"
        },
        {
            title: "Meet with Our Team",
            href: "/our-team"
        },
        {
            title: "Our Services",
            href: "/services"
        },
        {
            title: "Frequently Asked Questions",
            href: "/faq"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "bg-white",
        "aria-labelledby": "footer-heading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                id: "footer-heading",
                className: "sr-only",
                children: "Footer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:py-16 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:flex lg:justify-between lg:items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full lg:w-1/4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "w-auto h-16 mb-4",
                                        src: logo,
                                        alt: "Welfare Abroad",
                                        placeholder: "blur",
                                        sizes: "(max-width: 1200px) 100vw, 20vw"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-base text-gray-500",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "Treat yourself and choose Welfare Abroad."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-12 lg:mt-0 lg:w-3/4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    role: "list",
                                    className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-4",
                                    children: footerLinks.map(function(link, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: link.href,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "text-base text-gray-500 hover:text-gray-900",
                                                    children: link.title
                                                })
                                            })
                                        }, index);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-12 pt-8 border-t border-gray-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center mb-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaIcons/* default */.Z, {
                                    darker: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-base text-gray-400 text-center",
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " Welfare Abroad. All rights reserved."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js + 12 modules
var popover = __webpack_require__(1184);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 7 modules
var transition = __webpack_require__(4357);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MenuIcon.js
var MenuIcon = __webpack_require__(9065);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(3342);
// EXTERNAL MODULE: ./lib/classNames.ts
var classNames = __webpack_require__(9413);
// EXTERNAL MODULE: ./components/BlurImage.tsx
var BlurImage = __webpack_require__(1166);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
;// CONCATENATED MODULE: ./components/menus/ThreeColumnFlyoutMenu.tsx







var ThreeColumnFlyoutMenu = function(param) {
    var category = param.category, flyoutMenuState = param.flyoutMenuState, setFlyoutMenuState = param.setFlyoutMenuState;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
        className: "relative",
        children: function(param) {
            var open = param.open;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                        className: (0,classNames/* default */.Z)(open ? "text-gray-900" : "text-gray-500", "group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"),
                        onMouseEnter: function() {
                            return setFlyoutMenuState((0,_define_property/* default */.Z)({}, category.id, true));
                        },
                        onClick: function() {
                            return setFlyoutMenuState((0,_define_property/* default */.Z)({}, category.id, false));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/" + category.seo.slug,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: category.name
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                className: (0,classNames/* default */.Z)(open ? "text-gray-600" : "text-gray-400", "ml-2 h-5 w-5 group-hover:text-gray-500"),
                                "aria-hidden": "true"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        as: react.Fragment,
                        show: flyoutMenuState[category.id],
                        enter: "transition ease-out duration-200",
                        enterFrom: "opacity-0 translate-y-1",
                        enterTo: "opacity-100 translate-y-0",
                        leave: "transition ease-in duration-150",
                        leaveFrom: "opacity-100 translate-y-0",
                        leaveTo: "opacity-0 translate-y-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                            className: (0,classNames/* default */.Z)(category.thirdColumn ? "lg:max-w-5xl" : "lg:max-w-3xl", "absolute z-10 w-screen max-w-md mt-3 -ml-4 transform lg:ml-0 lg:left-1/2 lg:-translate-x-1/2"),
                            static: true,
                            onMouseLeave: function() {
                                return setFlyoutMenuState((0,_define_property/* default */.Z)({}, category.id, false));
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,classNames/* default */.Z)(category.thirdColumn ? "lg:grid-cols-3" : "lg:grid-cols-2", "relative grid gap-6 px-5 py-6 bg-white sm:gap-8 sm:p-8"),
                                        children: category.treatments.map(function(treatment) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/" + treatment.categories.map(function(category) {
                                                    return category.seo.slug;
                                                }).join("/") + "/" + treatment.seo.slug,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "flex items-start p-3 -m-3 rounded-lg hover:bg-gray-50",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "ml-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-base font-medium text-gray-900",
                                                                children: treatment.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "mt-1 text-sm text-gray-500",
                                                                children: treatment.description
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, treatment.id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "p-5 bg-gray-50 sm:p-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/plastic-surgeries-before-after-gallery",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "flow-root p-3 -m-3 rounded-md hover:bg-gray-100",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex items-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-base font-medium text-gray-900",
                                                            children: [
                                                                category.name,
                                                                " Before After Gallery"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "mt-1 text-sm text-gray-500",
                                                        children: [
                                                            "Browse our before-after gallery for ",
                                                            category.name
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var menus_ThreeColumnFlyoutMenu = (ThreeColumnFlyoutMenu);

;// CONCATENATED MODULE: ./components/Header.tsx











var Header = function(param) {
    var commonCategories = param.commonCategories, commonPages = param.commonPages;
    var flyoutMenus = commonCategories.filter(function(category) {
        return category.flyoutMenu;
    });
    var ref = (0,react.useState)(flyoutMenus.reduce(function(acc, cur) {
        acc[cur.id] = false;
        return acc;
    }, {
        more: false
    })), flyoutMenuState = ref[0], setFlyoutMenuState = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
            className: "relative bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between px-4 py-6 mx-auto sm:px-6 md:justify-start max-w-7xl md:space-x-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-start lg:w-0 lg:flex-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: "Welfare Abroad"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "w-48 h-16 cursor-pointer",
                                        src: logo,
                                        placeholder: "blur",
                                        alt: "Welfare Abroad Logo",
                                        sizes: "(max-width: 1200px) 15vw, 10vw"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "-my-2 -mr-2 md:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                className: "inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Open menu"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon/* default */.Z, {
                                        className: "w-6 h-6",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Group */.J.Group, {
                            as: "nav",
                            className: "hidden space-x-10 md:flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/hair-transplant/fue-hair-transplant",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-base font-medium text-gray-500 hover:text-gray-900",
                                        children: "Hair Transplant"
                                    })
                                }),
                                flyoutMenus.map(function(category) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menus_ThreeColumnFlyoutMenu, {
                                        category: category,
                                        flyoutMenuState: flyoutMenuState,
                                        setFlyoutMenuState: setFlyoutMenuState
                                    }, category.id);
                                }),
                                commonPages.map(function(page) {
                                    return page.rootMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/" + page.seo.slug,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "text-base font-medium text-gray-500 hover:text-gray-900",
                                            children: page.title || page.seo.slug
                                        })
                                    }, page.id);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
                                    className: "relative",
                                    children: function(param) {
                                        var open = param.open;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                    className: (0,classNames/* default */.Z)(open ? "text-gray-900" : "text-gray-500", "group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"),
                                                    onMouseEnter: function() {
                                                        return setFlyoutMenuState({
                                                            more: true
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "More"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                                            className: (0,classNames/* default */.Z)(open ? "text-gray-600" : "text-gray-400", "ml-2 h-5 w-5 group-hover:text-gray-500"),
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                    as: react.Fragment,
                                                    show: flyoutMenuState.more,
                                                    enter: "transition ease-out duration-200",
                                                    enterFrom: "opacity-0 translate-y-1",
                                                    enterTo: "opacity-100 translate-y-0",
                                                    leave: "transition ease-in duration-150",
                                                    leaveFrom: "opacity-100 translate-y-0",
                                                    leaveTo: "opacity-0 translate-y-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                                        className: "absolute z-10 w-screen max-w-xs px-2 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0",
                                                        static: true,
                                                        onMouseLeave: function() {
                                                            return setFlyoutMenuState({
                                                                more: false
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "relative grid gap-6 px-5 py-6 bg-white sm:gap-8 sm:p-8",
                                                                children: commonPages.filter(function(page) {
                                                                    return !page.excludeFromMenu;
                                                                }).map(function(page) {
                                                                    return !page.rootMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/" + page.seo.slug,
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            className: "block p-3 -m-3 rounded-md hover:bg-gray-50",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "text-base font-medium text-gray-900",
                                                                                    children: [
                                                                                        page.highlightedTitlePrefix,
                                                                                        " ",
                                                                                        page.title
                                                                                    ]
                                                                                }),
                                                                                page.description && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "mt-1 text-sm text-gray-500",
                                                                                    children: [
                                                                                        page.description.split(" ").slice(0, 15).join(" "),
                                                                                        "..."
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, page.id);
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "items-center justify-end hidden lg:flex md:flex-1 lg:w-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#contact-us",
                                className: "inline-flex items-center justify-center px-4 py-2 ml-8 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-secondary whitespace-nowrap hover:bg-lime-500",
                                children: "Get a Free Quote Now"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    as: react.Fragment,
                    enter: "duration-200 ease-out",
                    enterFrom: "opacity-0 scale-95",
                    enterTo: "opacity-100 scale-100",
                    leave: "duration-100 ease-in",
                    leaveFrom: "opacity-100 scale-100",
                    leaveTo: "opacity-0 scale-95",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                        focus: true,
                        className: "absolute inset-x-0 top-0 z-50 p-2 transition origin-top-right transform md:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bg-white divide-y-2 rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 divide-gray-50",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-5 pt-5 pb-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                                    className: "w-auto h-16 rounded-xl",
                                                    src: logo,
                                                    alt: "Welfare Abroad Logo",
                                                    sizes: "50vw"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "-mr-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                    className: "inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "Close menu"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                                            className: "w-6 h-6",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "px-5 py-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid grid-cols-2 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/hair-transplant/fue-hair-transplant",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "text-base font-medium text-gray-900 hover:text-gray-700",
                                                        children: "Hair Transplant"
                                                    })
                                                }),
                                                commonCategories.filter(function(category) {
                                                    return category.flyoutMenu;
                                                }).map(function(category) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: category.seo.slug,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "text-base font-medium text-gray-900 hover:text-gray-700",
                                                            children: category.name
                                                        })
                                                    }, category.id);
                                                }),
                                                commonPages.filter(function(page) {
                                                    return !page.excludeFromMenu;
                                                }).map(function(page) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: page.seo.slug,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "text-base font-medium text-gray-900 hover:text-gray-700",
                                                            children: [
                                                                page.highlightedTitlePrefix,
                                                                " ",
                                                                page.title
                                                            ]
                                                        })
                                                    }, page.id);
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "#contact-us",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "flex items-center justify-center w-full px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-secondary hover:bg-indigo-700",
                                                    children: "Get a Free Quote Now"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Header = (Header);

// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ExclamationIcon.js
var ExclamationIcon = __webpack_require__(8771);
;// CONCATENATED MODULE: ./components/PreviewAlert.tsx



var PreviewAlert = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-red-600",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-3 py-3 mx-auto max-w-7xl sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center flex-1 w-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "flex p-2 rounded-lg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationIcon/* default */.Z, {
                                    className: "w-6 h-6 text-white",
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "ml-3 font-medium text-white truncate",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "md:hidden",
                                        children: "Preview Alert"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "hidden md:inline",
                                        children: "You are currently in preview mode."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-shrink-0 order-3 w-full mt-2 sm:order-2 sm:mt-0 sm:w-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/api/exit-preview",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "flex items-center justify-center px-4 py-2 text-sm font-medium text-indigo-600 bg-white border border-transparent rounded-md shadow-sm hover:bg-indigo-50",
                                children: "Exit Preview Mode"
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_PreviewAlert = (PreviewAlert);

;// CONCATENATED MODULE: ./components/Layout.tsx
// @ts-nocheck













var Layout = function(_param) {
    var children = _param.children, preview = _param.preview, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "preview"
    ]);
    var consent = (0,index_es/* useCookieConsentContext */.uz)().consent;
    var ref = (0,react.useState)(false), cookieBanner = ref[0], setCookieBanner = ref[1];
    (0,react.useEffect)(function() {
        if (!consent.thirdParty) {
            setCookieBanner(true);
        } else {
            setCookieBanner(false);
        }
    }, [
        consent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col justify-between h-screen subpixel-antialiased",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* DefaultSeo */.lX, {
                openGraph: {
                    type: "website",
                    locale: "en_US",
                    url: baseUrl/* default */.Z,
                    images: [
                        {
                            url: baseUrl/* default */.Z + "/logo.png",
                            alt: "Welfare Abroad Logo"
                        }
                    ],
                    site_name: "Welfare Abroad"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* LogoJsonLd */.uJ, {
                logo: baseUrl/* default */.Z + "/logo.png",
                url: baseUrl/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BrandJsonLd */.hO, {
                id: baseUrl/* default */.Z,
                logo: baseUrl/* default */.Z + "/logo.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* WebPageJsonLd */.VL, {
                id: baseUrl/* default */.Z,
                lastReviewed: new Date().toISOString()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* SocialProfileJsonLd */.Sv, {
                type: "Organization",
                name: "Welfare Abroad",
                url: baseUrl/* default */.Z,
                sameAs: [
                    "https://www.facebook.com/hairtransplantabroad/",
                    "https://www.instagram.com/welfare.abroad/",
                    "https://uk.linkedin.com/in/welfare-abroad-520b441b3",
                    "https://www.youtube.com/channel/UCXx9z0C-q0lrLP44-MBdCrg", 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* LocalBusinessJsonLd */.wq, {
                type: "MedicalBusiness",
                id: baseUrl/* default */.Z,
                name: "Welfare Abroad",
                description: "Looking for affordable treatments in Istanbul, Turkey? Welfare Abroad offers fully customizable medical travel packages for FUE Hair Transplant, Dentistry.",
                url: baseUrl/* default */.Z,
                telephone: "+447503753001",
                address: {
                    streetAddress: "K\xfc\xe7\xfckbakkalk\xf6y, Sa\xe7 Ekimi B\xf6l\xfcm\xfc, Işıklar Cd. No: 28 D:Kat: 7",
                    addressLocality: "Ataşehir",
                    addressRegion: "İstanbul",
                    postalCode: "34750",
                    addressCountry: "TR"
                },
                geo: {
                    latitude: "40.985079",
                    longitude: "29.1098"
                },
                images: [
                    "".concat(baseUrl/* default */.Z, "/logo.png")
                ],
                openingHours: [
                    {
                        opens: "09:00",
                        closes: "20:00",
                        dayOfWeek: [
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday", 
                        ]
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header, (0,_object_spread/* default */.Z)({}, commonProps)),
            preview && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PreviewAlert, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "mb-auto",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "z-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                        className: "flex items-center justify-center mr-24 -mb-2",
                        smooth: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tawk_messenger_react_es/* default */.Z, {
                        propertyId: "63c8f31847425128790e7eef",
                        widgetId: "1gn4fb64o"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-40",
                children: cookieBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CookieConsentBanner, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, (0,_object_spread/* default */.Z)({}, commonProps))
        ]
    });
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 1692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_classNames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9413);





var accounts = [
    {
        name: "Facebook",
        href: "https://www.facebook.com/hairtransplantabroad/",
        icon: function(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                role: "img",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
            }, props), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Facebook"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
                        fill: "currentColor"
                    })
                ]
            }));
        }
    },
    {
        name: "Instagram",
        href: "https://www.instagram.com/welfare.abroad/",
        icon: function(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                role: "img",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
            }, props), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Instagram"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z",
                        fill: "currentColor"
                    })
                ]
            }));
        }
    },
    {
        name: "LinkedIn",
        href: "https://uk.linkedin.com/in/welfare-abroad-520b441b3",
        icon: function(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                role: "img",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
            }, props), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "LinkedIn"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
                        fill: "currentColor"
                    })
                ]
            }));
        }
    },
    {
        name: "YouTube",
        href: "https://www.youtube.com/channel/UCXx9z0C-q0lrLP44-MBdCrg",
        icon: function(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                role: "img",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
            }, props), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "YouTube"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                ]
            }));
        }
    },
    {
        name: "WhatsApp",
        href: "https://wa.me/905423625030",
        icon: function(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                role: "img",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
            }, props), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "WhatsApp"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                ]
            }));
        }
    }, 
];
var SocialMediaIcons = function(param) {
    var darker = param.darker, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        role: "list",
        className: "flex mt-8 space-x-12 ".concat(className),
        children: accounts.map(function(account) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: account.href,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        // className="text-indigo-200 hover:text-indigo-100"
                        className: (0,_lib_classNames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(darker ? "text-gray-400 hover:text-gray-500" : "text-indigo-200 hover:text-indigo-100"),
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "sr-only",
                                children: account.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(account.icon, {
                                className: "w-6 h-6",
                                "aria-hidden": "true"
                            })
                        ]
                    })
                })
            }, account.name);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialMediaIcons);


/***/ }),

/***/ 9836:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var baseUrl =  true ? "https://" + ("www.welfareabroad.com" || 0) : 0;
/* harmony default export */ __webpack_exports__["Z"] = (baseUrl);


/***/ }),

/***/ 9413:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var classNames = function() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
};
/* harmony default export */ __webpack_exports__["Z"] = (classNames);


/***/ })

}]);